<template>
  <div>
    <cricket-match-innings-menu
      :match="match"
      :matchUserPref="matchUserPref"
    ></cricket-match-innings-menu>

    <div
      v-for="(teamInn, i) in match.batting_order"
      v-if="i == matchUserPref.activeInnings"
      :key="i">
      <div v-if="state.isLoading()" class="center">
        Loading overs of {{match.teams[teamInn[0]].name}} (Inn: {{teamInn[1]}})
      </div>
      <div v-else-if="overs.length > i">
        <div class="filterable-content">
          <div class="left-part width300">
            <div class="group">
              <h5 class="silent">Highlights</h5>
              <ul>
                <li
                  v-for="(item, f) in getFilterables(i)"
                  :key="f"
                  :class="{active:item.isSame(activeFilter)}"
                  class="clickable box"
                  @click="fitlerFeature(item)">{{item.name}}</li>
              </ul>
            </div>
            <div class="group">
              <h5 class="silent">Batsmans</h5>
              <ul>
                <li
                  v-for="(item, f) in getBatsmans(i)"
                  :key="f"
                  :class="{active:item.isSame(activeFilter)}"
                  class="clickable box"
                  @click="fitlerFeature(item)">{{match.players[item.name].name}}</li>
              </ul>
            </div>
            <div class="group">
              <h5 class="silent">Bowlers</h5>
              <ul>
                <li
                  v-for="(item, f) in getBowlers(i)"
                  :key="f"
                  :class="{active:item.isSame(activeFilter)}"
                  class="clickable box"
                  @click="fitlerFeature(item)">{{match.players[item.name].name}}</li>
              </ul>
            </div>
            <div class="group">
              <h5 class="silent">Overs</h5>
              <ul>
                <li
                  v-for="(over, overI) in overs[i]"
                  :key="overI"
                  :class="{
                    'silent': !selectedOver && !shouldShowOver(i, overI),
                    'active': selectedOver==over.over}"
                  class="clickable tag"
                  @click="selectedOver=over.over">{{over.over}}</li>
              </ul>
            </div>
          </div>
          <div class="right-part">
            <match-commentary-over
              v-for="(over, overI) in overs[i]"
              v-if="shouldShowOver(i, overI)"
              :key="[i.toString(), overI.toString(), over.over].join('-')"
              :match="match"
              :over="over"
              :isLastOver="(overs[i].length - 1) === overI"
              :overKey="match.batting_order[i][0]+'_'+match.batting_order[i][1]+'_'+over.over"
              @playerSelected="onPlayerSelected"
              @ballSelected="onBallSelected"
            ></match-commentary-over>
          </div>
        </div>
      </div>
      <div v-else class="center">
        Commentary not found for Team: {{match.teams[teamInn[0]].name}}, Inn: {{teamInn[1]}}
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import AppEvents from '@/appevents'
import Utils from '@/utils'
import MatchCommentaryOver from './MatchCommentaryOver.vue'

class FilterableItem {
  constructor (group, key, name) {
    this.group = group
    this.key = key
    this.name = name || key
  }

  isSame (item) {
    if (!item) { return false }

    return this.group === item.group && this.key === item.key
  }
}

class FilterableGroup {
  constructor (feature, name) {
    this.feature = feature
    this.name = name
    this.items = []
  }
}

export default {
  components: {
    'MatchCommentaryOver': MatchCommentaryOver
  },
  data () {
    const filterableFeatures = [
      new FilterableItem('feature', 'all', 'All'),
      new FilterableItem('feature', 'fours', 'Fours'),
      new FilterableItem('feature', 'sixes', 'Sixes'),
      new FilterableItem('feature', 'wickets', 'Wickets')
    ]

    return {
      defaultFilterableFeatures: filterableFeatures,
      activeFilter: filterableFeatures[0],
      selectedOver: null,
      overs: [],
      state: DataState.newLoading()
    }
  },
  props: {
    match: Object,
    matchUserPref: Object
  },
  created () {
    this.$globalEvents.$on(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  beforeDestroy () {
    this.$globalEvents.$off(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  mounted () {
    this.fetchOvers()
  },
  methods: {
    onMatchUpdated (match) {
      if(!this.state.isLoaded()) {return}
      this.fetchOvers(true)
    },

    fetchOvers (useFresh) {
      if (!this.matchUserPref.userSelected) {
        this.matchUserPref.activeInnings = this.match.batting_order.length - 1
      }

      // console.log('Fetch overs for', this.match.key, useFresh)
      let innIndex = 0
      this.match.fetchOvers(useFresh).then((oversMap) => {
        // this.overs = []
        this.match.batting_order.forEach((teamInn) => {
          const inn = `${teamInn[0]}_${teamInn[1]}`
          if(this.overs.length <= innIndex) {
            this.overs.push([])
          }
          if (oversMap[inn]) {
            const newOvers = oversMap[inn].reverse()
            Utils.mergeArray(this.overs[innIndex], newOvers)
            // this.overs.push(oversMap[inn].reverse())
          } else {
            console.log('Overs missing', inn)
            // this.overs.push([])
          }

          innIndex++
        })

        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },

    fitlerFeature (item) {
      this.selectedOver = null
      this.activeFilter = item
    },

    shouldShowOver (inn, overI) {
      const innings = this.overs[inn]
      const over = innings[overI]

      if (this.selectedOver) {
        this.activeFilter = null
        return parseInt(over.over) == parseInt(this.selectedOver)
      }

      if (this.activeFilter == null || this.activeFilter.key == 'all') {
        return true
      }

      if (this.activeFilter.group === 'feature') {
        if (this.activeFilter.key == 'fours') {
          return over.fours > 0
        } else if (this.activeFilter.key == 'sixes') {
          return over.sixes > 0
        } else if (this.activeFilter.key == 'wickets') {
          return over.wicket > 0
        }
      } else if (this.activeFilter.group === 'batsman') {
        return over.haveBatsman(this.activeFilter.key)
      } else if (this.activeFilter.group === 'bowler') {
        return over.haveBowler(this.activeFilter.key)
      }

      return true
    },

    getFilterables (inn) {
      return this.defaultFilterableFeatures
    },

    getBatsmans (inn) {
      const innings = this.overs[inn]
      let players = []
      innings.forEach((over) => {
        over.batsman.forEach((playerOver) => {
          if (players.indexOf(playerOver.key) === -1) {
            players.push(playerOver.key)
          }
        })
      })

      let filterabls = []
      players.reverse().forEach((playerKey) => {
        filterabls.push(new FilterableItem('batsman', playerKey))
      })

      return filterabls
    },

    getBowlers (inn) {
      const innings = this.overs[inn]
      let players = []
      innings.forEach((over) => {
        over.bowler.forEach((playerOver) => {
          if (players.indexOf(playerOver.key) === -1) {
            players.push(playerOver.key)
          }
        })
      })

      let filterabls = []
      players.reverse().forEach((playerKey) => {
        filterabls.push(new FilterableItem('bowler', playerKey))
      })

      return filterabls
    },

    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    },
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
